var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1.7,1.7 7.3,1.7 7.3,2.7 3.4,2.7 8.3,7.5 7.5,8.3 2.7,3.4 2.7,7.3 1.7,7.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "15.7,7.5 20.6,2.7 16.7,2.7 16.7,1.7 22.3,1.7 22.3,7.3 21.3,7.3 21.3,3.4 16.5,8.3  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "22.3,22.3 16.7,22.3 16.7,21.3 20.6,21.3 15.7,16.5 16.5,15.7 21.3,20.6 21.3,16.7 22.3,16.7  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "8.3,16.5 3.4,21.3 7.3,21.3 7.3,22.3 1.7,22.3 1.7,16.7 2.7,16.7 2.7,20.6 7.5,15.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreen);
export default __webpack_public_path__ + "static/media/icon-fullscreen.94d3286981ed0678da735fdd8dc04bb8.svg";
export { ForwardRef as ReactComponent };